import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
